export const truncateString = (str: string, maxLength: number) => {
  return `${str.slice(0, maxLength)}...`;
};
